import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerBillingCustomerUnitListComponent } from './customer-billing-customer-unit-list/customer-billing-customer-unit-list.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ComponentsModule } from '@fi-app/components/components.module';
import { CustomerBillingCustomerUnitViewComponent } from './customer-billing-customer-unit-view/customer-billing-customer-unit-view.component';
import { CustomerBillingComponentsModule } from '../customer-billing-components/customer-billing-components.module';
import { CustomerBillingCustomerUnitEditComponent } from './customer-billing-customer-unit-edit/customer-billing-customer-unit-edit.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { BillingComponentsModule } from '@fi-app/billing/billing-components/billing-components.module';
import { CustomerBillingCustomerUnitListStateComponent } from './customer-billing-customer-unit-list/customer-billing-customer-unit-list-state.component';
import { MatCardModule } from '@angular/material/card';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CustomerBillingCustomerUnitEditCustomerInformationComponent } from './customer-billing-customer-unit-edit/customer-billing-customer-unit-edit-customer-information/customer-billing-customer-unit-edit-customer-information.component';
import { CustomerBillingCustomerUnitEditPaymentInformationComponent } from './customer-billing-customer-unit-edit/customer-billing-customer-unit-edit-payment-information/customer-billing-customer-unit-edit-payment-information.component';
import { CustomerBillingCustomerUnitEditCreditCardInformationComponent } from './customer-billing-customer-unit-edit/customer-billing-customer-unit-edit-credit-card-information/customer-billing-customer-unit-edit-credit-card-information.component';
import { CustomerBillingCustomerUnitEditCreditUsageInformationComponent } from './customer-billing-customer-unit-edit/customer-billing-customer-unit-edit-credit-usage-information/customer-billing-customer-unit-edit-credit-usage-information.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentsModule,
        FormsModule,
        UtilitiesModule,
        BillingComponentsModule,
        CustomerBillingComponentsModule,
        MatRadioModule,
        MatCardModule,
        FiPageHeaderModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    declarations: [
        CustomerBillingCustomerUnitListComponent,
        CustomerBillingCustomerUnitViewComponent,
        CustomerBillingCustomerUnitEditComponent,
        CustomerBillingCustomerUnitListStateComponent,
        CustomerBillingCustomerUnitEditCustomerInformationComponent,
        CustomerBillingCustomerUnitEditPaymentInformationComponent,
        CustomerBillingCustomerUnitEditCreditCardInformationComponent,
        CustomerBillingCustomerUnitEditCreditUsageInformationComponent,
    ],
})
export class CustomerBillingCustomerUnitModule {}
